import {IVimeoVideoConfig} from '../vimeo/IVimeoVideo';
import {IThronVideoConfig} from '../thron/IThronVideo';
import {ICloudflareStreamVideoConfig} from '../cloudflare-stream/ICloudflareStreamVideo';

export type IVideoConfig = IVimeoVideoConfig | IThronVideoConfig | ICloudflareStreamVideoConfig;

export enum EVideoProvider {
	THRON = 'Thron',
	VIMEO = 'Vimeo',
	CLOUDFLARE_STREAM = 'Cloudflare_Stream',
}

export type TAspectRatioResponse = {
	error?: boolean,
	message?: string,
	value?: string
}
